import React from "react";
import "./WaveIcon.css";

const WaveIcon = () => <div className="waveIconContainer"><span role="img" aria-label="wave" className="waveIcon">👋</span></div>

export default WaveIcon;